const anagramData = [
  {
    word: "CROWED",
    all: [
      // 3-letter words
      "RED", "ROW", "COW",
      // 4-letter words
      "CROW", "RODE", "CODE", "CORE", "WORD", 

    ],
  },
  {
    word: "TAKERS",
    all: [
      // 3-letter words
      "ART", "EAT", "TEA", "ASK", "ARK", "RAT","SET",
      // 4-letter words
      "TAKE", "TEAR", "RATE", "STAR", "EARS", "EAST",
      "SEAT", "REST", "RATS",
      // 5-letter words
      "TAKES", "RATES", "TEARS",
    ],
  },
  {
    word: "BRIGHT",
    all: [
      // 3-letter words
      "BIG", "HIT", "RIB", "RIG", "BIT",
      // 5-letter words
      "BIRTH", "RIGHT",
    ],
  },
  {
    word: "PLANET",
    all: [
      // 3-letter words
      "EAT", "TEA", "NET", "TEN", "TAN", "NAP", "PAN", "PEN",
      // 4-letter words
      "LATE", "TEAL", "NEAT", "LANE", "LEAN", "TALE",
      "PANT", "LEAP", "PANE",
      // 5-letter words
      "PLANT", "PLANE", "PANEL",
    ],
  },
  {
    word: "CATCHY",
    all: [
      // 3-letter words
      "ACT", "CAT", "HAT", "HAY", "SHY",
      // 4-letter words
      "CATH", "CHAT",
      // 5-letter words
      "CATCH", 
    ],
  },
  {
    word: "FRESHY",
    all: [
      // 3-letter words
      "SHY", "YES", "HER", "HEY", "SHE", "FRY",
      // 5-letter words
      "FRESH",
    ],
  },
  {
    word: "GREETA",
    all: [
      // 3-letter words
      "TEA", "RAT", "EAT", "EAR", "ARE",
      // 4-letter words
      "GEAR", "RATE", "TEAR", "GATE", "TREE",
      // 5-letter words
      "GREAT", "GRATE", "AGREE", 
    ],
  },
  {
    word: "GARDEN",
    all: [
      // 3-letter words
      "AGE", "AND", "ARE", "DEN", "EAR", "RAN", "RED",
      // 4-letter words
      "DARE", "DEAR", "EARN", "GEAR", "NEAR", "READ",

      // 5-letter words
      "ANGER", "GRADE", "RANGE", 
    ],
  },
  {
    word: "STREAM",
    all: [
      // 3-letter words
      "ART", "ARM", "EAR", "EAT", "MAT", "RAM",
      "RAT", "SEA", "SET", "TEA",
      // 4-letter words
      "EAST", "EARS", "MARS", "MATE", "MEAT", "RATE",
      "REST", "SEAM", "SEAT", "STAR", "TEAM", "TEAR", "TERM",
      // 5-letter words
      "MATES", "MEATS", "RATES", "STEAM", "TEARS",
    ],
  },
  {
    word: "IENFDR",
    all: [
      // 3-letter words
      "DEN", "FIN", "RED", "END",
      // 4-letter words
      "DINE", "FERN", "FIND", "RIDE",
      // 5-letter words
      "DINER", "FINED", "FRIED"
    ],
  },
];

export default anagramData;